import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResponseResult } from '@app/auth/model';
import { environment } from '@environments/environment';
import { Profile } from '../model';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private route: string = "teacher";
  private controller: string = "profile";
  private endpointPrefix: string;

  constructor(private http: HttpClient) {
    this.endpointPrefix = `${environment.urlAPI}/${this.route}/${this.controller}`;
  }

  getById(teacherId: string): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/${teacherId}`);
  }

  save(profile: Profile): any {
    return this.http.put<ResponseResult>(`${this.endpointPrefix}/update`, profile);
  }
}
